/* ============
 * All Organization Types
 * ============
 *
 * All organization types.
 */

import Vue from 'vue';
import store from './../../store';
import organizationTypeTransformer from './../../transformers/organizationType';

const success = ({ data }, resolve) => {
  const plans = organizationTypeTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllOrganizationTypes', plans);
  resolve();
};

const failed = () => {
};

// Display organization types.
export default () => {
  const p = new Promise((resolve, reject) => {
    Vue.$http.get('organization_types')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  });
  return p;
};



// WEBPACK FOOTER //
// ./src/app/services/organizationType/all.js